import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Navbar.css";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleScroll = () => {
      // Show navbar when scrolled down more than 50px
      setIsScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // If we're on the login page, don't render the navbar at all
  if (location.pathname === "/login") {
    return (
      <header className="navbar">
        <div className="brand">Erik og Jorid</div>
        <nav className="nav-links"></nav>
      </header>
    );
  }

  // Don't show navbar on mobile devices
  if (isMobile) {
    return null;
  }

  const handleSmoothScroll = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      const navbar = document.querySelector(".navbar") as HTMLElement;
      const navbarHeight = navbar ? navbar.offsetHeight : 0;
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      
      window.scrollTo({
        top: sectionTop - navbarHeight,
        behavior: "smooth",
      });
    }
  };

    const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.setItem("isLoggedIn", "false");
    navigate("/login");
  };

  return (
    <header className={`navbar ${isScrolled ? "visible" : "hidden"}`}>
      <a onClick={handleScrollTop} role="button" className="brand">Erik og Jorid</a>
      <nav className="nav-links">
        <a onClick={() => handleSmoothScroll("details")} role="button">Detaljer</a>
        <a onClick={() => handleSmoothScroll("kleskode")} role="button">Kleskode</a>
        <a onClick={() => handleSmoothScroll("onskeliste")} role="button">Gaveønsker</a>
        <a onClick={() => handleSmoothScroll("underholdning")} role="button">Underholdning</a>
        <a onClick={() => handleSmoothScroll("praktiskinfo")} role="button">Praktisk Informasjon</a>
        <a onClick={handleLogout} role="button">Logg ut</a>
      </nav>
    </header>
  );
}
